module.exports = __webpack_public_path__ + "app/community/community-detail-2lwsXSYD.html";